import { render, staticRenderFns } from "./simi-dialog-v2.vue?vue&type=template&id=1b17d26a&scoped=true&"
import script from "./simi-dialog-v2.vue?vue&type=script&lang=js&"
export * from "./simi-dialog-v2.vue?vue&type=script&lang=js&"
import style0 from "./simi-dialog-v2.vue?vue&type=style&index=0&lang=css&"
import style1 from "./simi-dialog-v2.vue?vue&type=style&index=1&id=1b17d26a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b17d26a",
  null
  
)

component.options.__file = "simi-dialog-v2.vue"
export default component.exports